import { validators } from '@blazar/tracking'
import gtm from '@blazar/tracking-google-tagmanager'
import { renderDataLayerObject } from 'tracking/dataLayerUtils'
import { screenTypeSelector } from 'tracking/dataCollectors'

const createDataLayerObject = (state) => renderDataLayerObject(screenTypeSelector(state))

export const trackScreenTypeChanged = {
  validators: [validators.redux('@blazar-plugin/device: Update screen type', () => true)],
  events: [gtm.event(({ state }) => createDataLayerObject(state, {}))],
}
